import React, { useId } from 'react';

export const MmcLabel = ({ children, icon: Icon = null, className = '', htmlFor, ...props }) => (
    <label className={`mmc-label ${className}`} htmlFor={htmlFor} {...props}>
        {Icon && <Icon size={16} weight="bold" />}
        {children}
    </label>
);

export const MmcInput = ({
    label,
    icon: Icon = null,
    error,
    id,
    className = '',
    wrapperClassName = '',
    ...props
}) => {
    const generatedId = useId();
    const inputId = id || generatedId;
    const errorId = `${inputId}-error`;

    return (
        <div className={`mmc-input-wrapper ${wrapperClassName}`}>
            {label && <MmcLabel icon={Icon} htmlFor={inputId}>{label}</MmcLabel>}
            <input
                id={inputId}
                className={`mmc-input ${className}`}
                aria-invalid={!!error}
                aria-describedby={error ? errorId : undefined}
                {...props}
            />
            {error && (
                <span id={errorId} className="mmc-input-error" role="alert">
                    {error}
                </span>
            )}
        </div>
    );
};

export const MmcTextArea = ({
    label,
    icon: Icon = null,
    error,
    id,
    className = '',
    wrapperClassName = '',
    ...props
}) => {
    const generatedId = useId();
    const inputId = id || generatedId;
    const errorId = `${inputId}-error`;

    return (
        <div className={`mmc-input-wrapper ${wrapperClassName}`}>
            {label && <MmcLabel icon={Icon} htmlFor={inputId}>{label}</MmcLabel>}
            <textarea
                id={inputId}
                className={`mmc-textarea ${className}`}
                aria-invalid={!!error}
                aria-describedby={error ? errorId : undefined}
                {...props}
            />
            {error && (
                <span id={errorId} className="mmc-input-error" role="alert">
                    {error}
                </span>
            )}
        </div>
    );
};
